var _defs, _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialIconFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1{fill:#3b5999}.cls-2{fill:#fff}.cls-3{fill:none}\r\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\r\n    facebook-color\r\n  ") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15 29A14 14 0 1 0 1 15a14 14 0 0 0 14 14"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19.1 9.72h-1.49c-1.17 0-1.39.56-1.39 1.37v1.79H19l-.37 2.81h-2.41v7.2h-2.9v-7.2H10.9v-2.81h2.42v-2.07a3.39 3.39 0 0 1 3.62-3.71 18.53 18.53 0 0 1 2.16.11z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 15,
    cy: 15,
    r: 14
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIconFacebook);
export default __webpack_public_path__ + "static/media/social-icon-facebook.46eeeaacd9779960bbba997326c02e10.svg";
export { ForwardRef as ReactComponent };